'use strict';

exports.__esModule = true;
exports.SVGIcon = undefined;

var _SVGIcon2 = require('./SVGIcon');

var _SVGIcon3 = _interopRequireDefault(_SVGIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SVGIcon3.default;
exports.SVGIcon = _SVGIcon3.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/SVGIcons/index.js
// module id = 71
// module chunks = 79611799117203 129745722219136 183400410456155 259661066386442